import React, { useEffect, useState } from 'react';
import * as FaIcons from 'react-icons/fa';
import { formatDateToLocal } from '../functions/dates';
import { getData, handleError } from '../functions/services';
import Loader from './common/Loader';
import ModalProyectsRanking from './modal/ModalProyectsRanking';
import Modal from 'react-responsive-modal';

const ProyectsRanking = () => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [openModal, setOpenModal] = useState(false);

    useEffect(() => {
        loadData();
    }, []);

    const onCloseModal = () => {
        setOpenModal(false);
    };

    const loadData = async () => {
        try {
            const req = await getData('dashboard/proyects-ranking', {});
            setData(req.data);
            setLoading(false);
        } catch (error) {
            console.log(error);
            handleError(error);
        }
    };

    const renderTable = () => {
        const tableData = data.map((val, i) => {
            return (
                <tr key={i}>
                    <td className="tac">{i + 1}</td>
                    <td>{`${val.company.name}-${val.city}-${formatDateToLocal(val.createdAt)}`}</td>
                    <td className="tac">{val.points.toFixed(1)}</td>                    
                </tr>
            );
        });

        return (
            <>
                <table className="table table-striped table-sm">
                    <thead className="tac">
                        <tr>
                            <th>#</th>
                            <th>Nombre</th>
                            <th>Ptos</th>                            
                        </tr>
                    </thead>
                    <tbody>{tableData}</tbody>
                </table>
                <div className="tac">
                    <a
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            setOpenModal(true);
                        }}
                    >
                        Ver detalles
                    </a>
                </div>
            </>
        );
    };

    return (
        <div class="card border-success ">                
                <div class="card-body">
                  <h6>{'Mejores Proyectos'}</h6>
                    {loading ? (
                        <div className="center-flex">
                            <Loader />
                        </div>
                    ) : (
                        renderTable()
                    )}
                </div>  
                <Modal
                classNames={{ modal: 'modal-size' }}
                open={openModal}
                onClose={onCloseModal}
                center>
                <ModalProyectsRanking close={onCloseModal} />
            </Modal>             
        </div>        
    );
};

export default ProyectsRanking;
